var map = {
	"./external.png": 4254,
	"./form/externalInfo.png": 6955,
	"./form/image1.png": 9038,
	"./form/image15.png": 8295,
	"./form/image2.png": 7668,
	"./form/image3.png": 1109,
	"./form/image4.png": 7721,
	"./form/image5.png": 817,
	"./form/nickelodeon2.png": 9904,
	"./form/placeholder.png": 4267,
	"./info/externalInfo.png": 11,
	"./info/image6.png": 1888,
	"./info/image7.png": 6999,
	"./jewels/image1.png": 2318,
	"./jewels/image2.png": 42,
	"./jewels/image3.png": 6594,
	"./jewels/image4.png": 4172,
	"./jewels/image5.png": 3699,
	"./logo-exotic.png": 2828,
	"./logos/Frame284.svg": 9370,
	"./logos/Frame285.svg": 6124,
	"./logos/Frame286.svg": 9893,
	"./logos/Frame287.svg": 4187,
	"./logos/Frame288.svg": 5468,
	"./logos/Group4.png": 2507,
	"./logos/fondo_marcas.png": 8428,
	"./logos/img-logos.png": 4953,
	"./slider1.png": 371,
	"./slider2.png": 9958,
	"./slider3.png": 1059,
	"./slider4.png": 5500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;